import { FunnelHeaderMilestone, FunnelHeaderStepType } from "pax-ui/components";

import { Product } from "../../../store/shared/product";
import { getPagePath, Page } from "../../shared/shared-route.constant";

// Application (Term Life Insurance)
export const applicationLimitedOfferPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.APPLICATION_LIMITED_OFFER,
);

export const applicationPdfPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.APPLICATION_PDF,
);

export const applicationUploadIdPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.APPLICATION_UPLOAD_ID,
);

export const applicationDigitalSignatureAutomaticRedirectPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.APPLICATION_DIGITAL_SIGNATURE_AUTOMATIC_REDIRECT,
);

export const applicationDigitalSignatureSuccessPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.APPLICATION_DIGITAL_SIGNATURE_SUCCESS,
);

export const applicationDigitalSignatureErrorPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.APPLICATION_DIGITAL_SIGNATURE_ERROR,
);

export const applicationDigitalSignatureDeclinedPagePath = getPagePath(
  Product.TERM_LIFE_INSURANCE_CONSTANT,
  Page.APPLICATION_DIGITAL_SIGNATURE_DECLINED,
);

export const applicationExpiredPagePath = Page.APPLICATION_HAS_EXPIRED;

// Note: We can't use our existing CustomRoute[] as we would then have a cyclic dependency
// Note: Pay attention to the order of the entries as they are used to display the breadcrumbs for the progress bar
export const applicationFunnelHeaderMilestones: FunnelHeaderMilestone[] = [
  {
    title: $localize`Digitale Unterschrift`,
    text: $localize`Dank digitalem Abschluss können Sie die Versicherung einfach online abschliessen.`,
    steps: [
      {
        title: $localize`Ihr Antrag`,
        path: applicationPdfPagePath,
        type: FunnelHeaderStepType.DIGITAL_APPLICATION,
      },
      {
        title: $localize`Ausweis hochladen`,
        path: applicationUploadIdPagePath,
        type: FunnelHeaderStepType.DIGITAL_APPLICATION,
      },
      {
        title: $localize`Geschafft!`,
        path: applicationDigitalSignatureSuccessPagePath,
        type: FunnelHeaderStepType.DIGITAL_APPLICATION,
      },
    ],
  },
  {
    title: $localize`Fertig`,
    text: $localize`Sie erhalten Ihre Police in wenigen Tagen.`,
    steps: [],
  },
];
